import { Currency } from '@/api/types/public';
import { CoatingItem } from '@/app/_lens-components/types';

import {
  handleCoatingDiscountPercent,
  handleCoatingPriceInfo,
  hasCoatingMemberPrice,
} from '@/app/_lens-components/utils';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import React, { useEffect, useState } from 'react';

export default function Price({
  renderPrice,
  currency,
  currencyName,
  coatingItem,
}: {
  renderPrice: (
    price?: string,
    sellPrice?: string,
    discountPercent?: number,
    hasMemberPrice?: boolean,
  ) => React.ReactNode;
  currency?: Currency;
  currencyName?: string;
  coatingItem: CoatingItem;
}) {
  const currencyList = useStore((state) => state.currencyList);
  const currencyStore = useStore((state) => state.currency);
  const [nowCurrency] = useState<Currency>(
    currency || currencyList.find((item) => item.name === currencyName) || currencyStore,
  );
  const userInfo = useStore((state) => state.userInfo);
  const [nowPrice, setNowPrice] = useState<string>('');
  const [nowSellPrice, setNowSellPrice] = useState<string>('');
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  const [hasMemberPrice, setHasMemberPrice] = useState<boolean>(false);
  useEffect(() => {
    if (coatingItem) {
      const nowPriceInfo = handleCoatingPriceInfo(coatingItem, nowCurrency, userInfo);

      setNowPrice(nowPriceInfo?.price);
      setNowSellPrice(nowPriceInfo?.sell_price);
      setDiscountPercent(handleCoatingDiscountPercent(coatingItem, userInfo));
      setHasMemberPrice(hasCoatingMemberPrice(coatingItem, userInfo));
    }
  }, [userInfo]);
  return renderPrice(
    nowPrice !== nowSellPrice && nowPrice ? formatPriceNumberWithSymbol(nowPrice, nowCurrency) : '',
    nowSellPrice ? formatPriceNumberWithSymbol(nowSellPrice, nowCurrency) : '',
    discountPercent,
    hasMemberPrice,
  );
}
